import React from "react";

const ProductDetailsAccordion = ({
  product,
  isOpen,
}) => {
  if (!isOpen) return null;

  return (
    <div
      id="product-details-accordion"
      className="mt-12 overflow-hidden rounded-3xl border border-gray-100 bg-white shadow-sm transition-all duration-300"
    >
      <div className="p-6 sm:p-8 space-y-8">
        {product.description && (
          <div>
            <h3 className="mb-3 text-base font-bold text-gray-900">
              Description
            </h3>
            <div
              className="prose prose-sm max-w-none text-gray-700 prose-headings:text-gray-900 prose-strong:text-gray-900 sm:prose"
              dangerouslySetInnerHTML={{ __html: product.description }}
            />
          </div>
        )}
        {product.specifications &&
          product.specifications.replace(/<[^>]*>/g, "").trim() && (
            <div>
              <h3 className="mb-3 text-base font-bold text-gray-900">
                Specifications
              </h3>
              <div
                className="prose prose-sm max-w-none text-gray-700 prose-headings:text-gray-900 prose-strong:text-gray-900 sm:prose"
                dangerouslySetInnerHTML={{ __html: product.specifications }}
              />
            </div>
          )}
        <div>
          <h3 className="mb-3 text-base font-bold text-gray-900">
            Product Details
          </h3>
          <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
            {[
              { label: "Category", value: product.category_name },
              { label: "Subcategory", value: product.subcategory_name },
              { label: "Brand", value: product.brand_name },
              {
                label: "Available Sizes",
                value: product.variants
                  ?.map((v) => `${v.variant_name}${v.unit_name ? ` ${v.unit_name}` : ''}`)
                  .join(", "),
              },
              {
                label: "Price Range",
                value:
                  product.variants?.length > 0
                    ? `Rs ${Math.min(...product.variants.map((v) => v.discount_price)).toFixed(0)} - Rs ${Math.max(...product.variants.map((v) => v.discount_price)).toFixed(0)}`
                    : null,
              },
              { label: "In Stock", value: "Yes" },
              { label: "Diet Type", value: "Vegetarian" },
              { label: "Country of Origin", value: "India" },
            ]
              .filter((row) => row.value)
              .map(({ label, value }) => (
                <div
                  key={label}
                  className="flex items-start justify-between gap-4 rounded-xl bg-gray-50 px-4 py-3"
                >
                  <span className="shrink-0 text-sm font-semibold text-gray-500">
                    {label}
                  </span>
                  <span className="text-right text-sm font-bold text-gray-900">
                    {value}
                  </span>
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetailsAccordion;
